import React from 'react';
import { NavItem } from './BaseLayout';
import {
  LayoutDashboard, Building2, Users, CreditCard, ClipboardCheck, Coins,
  BarChart3, AlignLeft, MessageSquare, List, ListOrdered, Clock,
  LayoutGrid, BookOpen, Image, Mail, Settings, Paintbrush, KeyRound,
  User, Lock, Monitor, AlertCircle, BarChart2,
} from 'lucide-react';

export interface LayoutConfig {
  sidebarTitle: string;
  sidebarDescription: string;
  headerSubtitle: string;
  rootPath: string;
  navItems: NavItem[];
}

export const layoutConfigs: Record<string, LayoutConfig> = {
  admin: {
    sidebarTitle: "Administration",
    sidebarDescription: "Manage platform users, organizations and system settings",
    headerSubtitle: "Admin Panel",
    rootPath: "/admin",
    navItems: [
      { label: 'Dashboard', href: '/admin', icon: <LayoutDashboard className="w-5 h-5" /> },
      { label: 'Organizations', href: '/admin/orgs', icon: <Building2 className="w-5 h-5" /> },
      { label: 'Users', href: '/admin/users', icon: <Users className="w-5 h-5" /> },
      { label: 'Billing', href: '/admin/billing', icon: <CreditCard className="w-5 h-5" /> },
      { label: 'Plan Features', href: '/admin/billing/features', icon: <ClipboardCheck className="w-5 h-5" /> },
      { label: 'Credit Grants', href: '/admin/credits', icon: <Coins className="w-5 h-5" /> },
      { label: 'LLM Usage', href: '/admin/llm/usage', icon: <BarChart3 className="w-5 h-5" /> },
      { label: 'LLM Logs', href: '/admin/llm/logs', icon: <AlignLeft className="w-5 h-5" /> },
      { label: 'LLM Playground', href: '/admin/llm/playground', icon: <MessageSquare className="w-5 h-5" /> },
      { label: 'Jobs', href: '/admin/jobs', icon: <List className="w-5 h-5" /> },
      { label: 'Jobs List', href: '/admin/jobs/list', icon: <ListOrdered className="w-5 h-5" /> },
      { label: 'Scheduled Jobs', href: '/admin/jobs/scheduled', icon: <Clock className="w-5 h-5" /> },
      { label: 'Canvas Templates', href: '/admin/canvas-templates', icon: <LayoutGrid className="w-5 h-5" /> },
      { label: 'Use Cases', href: '/admin/use-cases', icon: <ClipboardCheck className="w-5 h-5" /> },
      { label: 'Blog', href: '/admin/blog', minRole: 'marketer', icon: <BookOpen className="w-5 h-5" /> },
      { label: 'Media', href: '/admin/media', minRole: 'marketer', icon: <Image className="w-5 h-5" /> },
      { label: 'Invitations', href: '/admin/invites', icon: <Mail className="w-5 h-5" /> },
      { label: 'Support', href: '/admin/feedback', minRole: 'marketer', icon: <MessageSquare className="w-5 h-5" /> },
      { label: 'Knowledge Base', href: '/admin/knowledge', minRole: 'marketer', icon: <BookOpen className="w-5 h-5" /> },
      { label: 'Support Settings', href: '/admin/feedback/settings', minRole: 'marketer', icon: <Settings className="w-5 h-5" /> },
      { label: 'Styleguide', href: '/admin/styleguide', icon: <Paintbrush className="w-5 h-5" /> }
    ]
  },

  organization: {
    sidebarTitle: "Organization",
    sidebarDescription: "Manage your organization settings and preferences",
    headerSubtitle: "Organization Settings",
    rootPath: "/organization",
    navItems: [
      { label: 'Overview', href: '/organization', icon: <BarChart2 className="w-5 h-5" /> },
      { label: 'Members & Invites', href: '/organization/members', icon: <Users className="w-5 h-5" /> },
      { label: 'Gallery', href: '/organization/gallery', icon: <Image className="w-5 h-5" /> },
      { label: 'Canvases', href: '/organization/canvases', icon: <LayoutGrid className="w-5 h-5" /> },
      { label: 'Organization', href: '/organization/about', icon: <Building2 className="w-5 h-5" />, comingSoon: false },
      { label: 'Credits & Usage', href: '/organization/credits', icon: <Coins className="w-5 h-5" /> },
      { label: 'Billing & Subscription', href: '/organization/billing', icon: <CreditCard className="w-5 h-5" /> },
      { label: 'Integrations', href: '/organization/integrations', icon: <KeyRound className="w-5 h-5" /> }
    ]
  },

  account: {
    sidebarTitle: "Your Account",
    sidebarDescription: "Manage your profile, security and devices",
    headerSubtitle: "Account Settings",
    rootPath: "/settings/account",
    navItems: [
      { label: 'Profile', href: '/settings/account/profile', icon: <User className="w-5 h-5" /> },
      { label: 'Security', href: '/settings/account/security', icon: <Lock className="w-5 h-5" /> },
      { label: 'Sessions', href: '/settings/account/sessions', icon: <Monitor className="w-5 h-5" /> },
      { label: 'Danger Zone', href: '/settings/account/danger', icon: <AlertCircle className="w-5 h-5" /> }
    ]
  }
};
